<div class="content-container" lang="en">
  <div class="content">
    <header>
      <a [href]="skipLinkPath" class="skip-link">Skip to main content</a>
      <app-loader></app-loader>
      <mat-toolbar *ngIf="router.url !== '/auth'" class="mat-toolbar-main" color="primary" #toolbar>
        <div class="header-shell">
          <div class="ewrs-brand">
            <img
              class="logo"
              [class.mobileLogo]="isMobileHeaderTitle"
              [src]="isMobileHeaderTitle ? 'assets/images/ontario-logo-small.png' : 'assets/images/ontario-logo.png'"
              alt="Government of Ontario logo"
            />
            <span
              class="headerTitle"
              [class.mobileHeaderTitle]="isMobileHeaderTitle"
              aria-label="Employee Workspace Reservation System (EWRS)"
            >
              {{ isMobileHeaderTitle ? 'EWRS' : 'Employee Workspace Reservation System' }}
            </span>
          </div>

          <button
            class="account-menu-button button-focus"
            [class.mobileAccountMenu]="isMobileHeaderTitle"
            mat-button
            [matMenuTriggerFor]="accountMenu"
            type="button"
            [attr.aria-label]="(userAccount?.name || 'Account') + ' account menu'"
          >
            <span class="header-icon header-icon-account" aria-hidden="true"></span>
            <span class="headerItem">{{ userAccount?.name || 'Account' }}</span>
            <span class="header-icon header-icon-chevron" aria-hidden="true"></span>
          </button>

          <mat-menu #accountMenu xPosition="before">
            <!--button *ngIf="userAccount" (click)="logout()" matTooltip="Click to sign out" mat-menu-item>
              <fa-icon class="clickable-icon" [icon]="faSignOutAlt"></fa-icon>
              Sign out
            </button-->
            <button *ngIf="!userAccount" (click)="login()" matTooltip="Click to sign in" mat-menu-item>
              <fa-icon class="clickable-icon menu-icon" [icon]="faSignInAlt"></fa-icon>
              Sign in
            </button>

            <button
              *ngIf="userAccount"
              matTooltip="Click to edit account settings"
              mat-menu-item
              (click)="editProfile()"
            >
              <fa-icon class="menu-icon" [icon]="faCog"></fa-icon>
              Settings
            </button>

            <button matTooltip="Click to view user guide" mat-menu-item (click)="viewUserGuide()">
              <fa-icon class="menu-icon" [icon]="faBook"></fa-icon>
              User guide
            </button>

            <button mat-menu-item [matMenuTriggerFor]="themeMenu">
              <fa-icon class="menu-icon" [icon]="faPalette"></fa-icon>
              Theme
            </button>
          </mat-menu>

          <mat-menu #themeMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="setSystemMode()" [disabled]="themePreference === 'system'">
              <fa-icon class="menu-icon" [icon]="faPalette"></fa-icon>
              System
            </button>
            <button mat-menu-item (click)="setLightMode()" [disabled]="themePreference === 'light'">
              <fa-icon class="menu-icon" [icon]="faSun"></fa-icon>
              Light
            </button>
            <button mat-menu-item (click)="setDarkMode()" [disabled]="themePreference === 'dark'">
              <fa-icon class="menu-icon" [icon]="faMoon"></fa-icon>
              Dark
            </button>
          </mat-menu>
        </div>
      </mat-toolbar>
      <mat-toolbar
        *ngIf="router.url !== '/auth' && userAccount && userRoles"
        class="mat-toolbar-menu"
        role="navigation"
        aria-label="Primary"
        #menuToolbar
      >
        <div *ngIf="isMobile && userAccount && userRoles" class="mobile-nav">
          <button class="mobile-nav-button" mat-button [matMenuTriggerFor]="menu" type="button" aria-label="Open menu">
            <mat-icon id="hamburger">menu</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button *ngIf="authorizeHome()" routerLink="/home" (click)="setMobileMenu('Home')" mat-menu-item>
              Home
            </button>
            <button
              *ngIf="authorizeHome()"
              routerLink="/reservations"
              (click)="setMobileMenu('My bookings')"
              mat-menu-item
            >
              My bookings
            </button>
            <button *ngIf="authorizeMyTeam()" routerLink="/my-team" (click)="setMobileMenu('My team')" mat-menu-item>
              My team
            </button>
            <button
              *ngIf="authorizeSpace()"
              routerLink="/workstations"
              (click)="setMobileMenu('Manage workstations')"
              mat-menu-item
            >
              Manage workstations
            </button>
            <button
              *ngIf="authorizeBuildings()"
              routerLink="/buildings"
              (click)="setMobileMenu('Manage buildings')"
              mat-menu-item
            >
              Manage buildings
            </button>
            <button
              *ngIf="authorizeSpaceAdminBuildings()"
              routerLink="/buildings"
              (click)="setMobileMenu('View buildings')"
              mat-menu-item
            >
              View buildings
            </button>
            <button *ngIf="authorizeUsers()" routerLink="/users" (click)="setMobileMenu('Manage users')" mat-menu-item>
              Manage users
            </button>
            <button
              *ngIf="authorizeDivision()"
              routerLink="/divisions"
              (click)="setMobileMenu('Manage divisions')"
              mat-menu-item
            >
              Manage divisions
            </button>
            <button
              *ngIf="authorizeSpaceAdminDivision()"
              routerLink="/divisions"
              (click)="setMobileMenu('View divisions')"
              mat-menu-item
            >
              View divisions
            </button>
            <button
              *ngIf="authorizeReport()"
              routerLink="/reports"
              (click)="setMobileMenu('Extract report')"
              mat-menu-item
            >
              Extract report
            </button>
          </mat-menu>
          <span class="mobile-nav-title">{{ mobileTitle }}</span>
        </div>
        <div *ngIf="!isMobile && userAccount && userRoles" class="nav-tabs" [class.nav-tabs-compact]="isCompactNav">
          <a
            class="menu-item toolbarLink"
            *ngIf="authorizeHome()"
            routerLink="/home"
            [routerLinkActive]="['menu-item-active']"
            (click)="setMobileMenu('Home')"
          >
            Home
          </a>
          <a
            class="menu-item toolbarLink"
            *ngIf="authorizeHome()"
            routerLink="/reservations"
            [routerLinkActive]="['menu-item-active']"
            (click)="setMobileMenu('My bookings')"
          >
            My bookings
          </a>
          <a
            class="menu-item toolbarLink"
            *ngIf="authorizeMyTeam()"
            routerLink="/my-team"
            [routerLinkActive]="['menu-item-active']"
            (click)="setMobileMenu('My team')"
          >
            My team
          </a>
          <a
            class="menu-item toolbarLink"
            *ngIf="authorizeSpace()"
            routerLink="/workstations"
            [routerLinkActive]="['menu-item-active']"
            (click)="setMobileMenu('Manage workstations')"
          >
            Manage workstations
          </a>
          <a
            class="menu-item toolbarLink"
            *ngIf="authorizeBuildings()"
            routerLink="/buildings"
            [routerLinkActive]="['menu-item-active']"
            (click)="setMobileMenu('Manage buildings')"
          >
            Manage buildings
          </a>
          <a
            class="menu-item toolbarLink"
            *ngIf="authorizeSpaceAdminBuildings()"
            routerLink="/buildings"
            [routerLinkActive]="['menu-item-active']"
            (click)="setMobileMenu('View buildings')"
          >
            View buildings
          </a>
          <a
            class="menu-item toolbarLink"
            *ngIf="authorizeUsers()"
            routerLink="/users"
            [routerLinkActive]="['menu-item-active']"
            (click)="setMobileMenu('Manage users')"
          >
            Manage users
          </a>
          <a
            class="menu-item toolbarLink"
            *ngIf="authorizeDivision()"
            routerLink="/divisions"
            [routerLinkActive]="['menu-item-active']"
            (click)="setMobileMenu('Manage divisions')"
          >
            Manage divisions
          </a>
          <a
            class="menu-item toolbarLink"
            *ngIf="authorizeSpaceAdminDivision()"
            routerLink="/divisions"
            [routerLinkActive]="['menu-item-active']"
            (click)="setMobileMenu('View divisions')"
          >
            View divisions
          </a>
          <a
            class="menu-item toolbarLink"
            *ngIf="authorizeReport()"
            routerLink="/reports"
            [routerLinkActive]="['menu-item-active']"
            (click)="setMobileMenu('Extract report')"
          >
            Extract report
          </a>
        </div>
      </mat-toolbar>
    </header>
    <div role="main" id="main-content">
      <app-alert></app-alert>
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer *ngIf="router.url !== '/register'" class="footer"></app-footer>
</div>
